<template>
  <div
    v-loading="table.loading"
    class="detail-diff-table"
  >
    <div
      v-for="table in table.list"
      :key="table.table_id"
      style="margin-bottom: 5px"
    >
      <el-table
        :data="table._showAll 
          ? (table.compare_columns || []) 
          : (table.compare_columns || []).filter(i => i.is_change)"
        style="width: 100%"
        size="mini"
        border
        :span-method="detailSpanFn"
        :cell-class-name="detailTableCellClass"
        :row-class-name="detailTableRowClass"
      >
        <el-table-column :label="tableTitle(table)">
          <el-table-column :width="200">
            <!-- eslint-disable vue/no-unused-vars -->
            <template
              slot="header"
              slot-scope="scope"
            >
              <!-- eslint-enable vue/no-unused-vars -->
              <div style="display:flex; align-items: center;line-height: 23px;">
                <el-switch v-model="table._showAll" />
                <span style="margin-left: 6px; font-size: 12px;">
                  {{ table._showAll ? '展示所有字段' : '展示变更字段' }}
                </span>
              </div>
            </template>
            <template slot-scope="scope">
              <el-tooltip
                effect="light"
                placement="bottom-start"
                :disabled="!scope.row.comment"
              >
                <div
                  slot="content"
                  style="max-width: 200px; line-height: 18px;"
                >
                  {{ scope.row.comment }}
                </div>
                <span class="fields-tips">
                  {{ scope.row.column }}
                  <i
                    v-show="!!scope.row.comment"
                    class="el-icon-warning-outline"
                  />
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="操作前"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.is_json">{{ scope.row.before_value }}</span>
              <span
                v-else
                style="cursor: pointer; font-size: 12px; color: #409eff;"
                @click="handleViewJson(scope.row.before_value)"
              >
                查看详细json
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作后"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.is_json">{{ scope.row.after_value }}</span>
              <span
                v-else
                style="cursor: pointer; font-size: 12px; color: #409eff;"
                @click="handleViewJson(scope.row.after_value)"
              >
                查看详细json
              </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>

    <json-drawer 
      :visible.sync="detailDrawer.visible"
      :json="detailDrawer.data"
    />
  </div>
</template>

<script>
import JsonDrawer from '@/components/JsonDrawer';
import Request from '@/core/QuRequest';

const req = new Request();

// 记录的操作类型type
const OpType = {
  1: '新增',
  2: '修改',
  3: '删除',
};

export default {
  name: 'LogDetail',
  components: {
    'json-drawer': JsonDrawer,
  },
  props: {
    id: { type: Number, default: '' },
  },
  data() {
    return {
      table: {
        loading: false,
        list: [],
      },
      detailDrawer: {
        visible: false,
        data: '',
      },
    };
  },
  watch: {
    id: {
      handler: '_getList',
      immediate: true,
    },
  },
  methods: {
    async _getList() {
      this.table.loading = true;
      const res = await req
        .send(req.Apis.common.getLogDetailList, { operation_log_id: this.id })
        .fin(() => {
          this.table.loading = false;
        });
      let list = res.data || [];
      list.forEach((item) => {
        item._showAll = false;
      });
      this.table.list = list;
    },

    tableTitle(table = {}) {
      const tb = `【table】：${table.table} / ${table.table_id}`;
      const op = `【操作类型】：${OpType[table.type] || '--'} / ${table.tips}`;
      return tb + op;
    },

    handleViewJson(data = '{}') {
      this.detailDrawer.data = parseConf(data);
      this.detailDrawer.visible = true;
    },

    detailSpanFn({ row, column, rowIndex, columnIndex }) {
      if (!row.is_change) {
        if (columnIndex === 1) {
          return [1, 2];
        } else if (columnIndex === 2) {
          return [0, 0];
        }
      }
    },

    detailTableCellClass({ row, column, rowIndex, columnIndex }) {
      return columnIndex === 0 ? 'detail-label' : '';
    },

    detailTableRowClass({ row, rowIndex }) {
      return row.is_change ? 'diffs-row' : '';
    },
  },
};

// parseConfig
function parseConf(conf = '{}') {
  try {
    return JSON.parse(conf);
  } catch (e) {
    return {};
  }
}
</script>
<style lang="less">
.detail-diff-table {
  .el-table th div {
    line-height: 23px;
    .el-switch {
      height: 23px;
    }
  }
}
</style>

<style lang="less" scoped>
.detail-diff-table {
  .fields-tips {
    font-size: 12px;
  }
  .el-table th div {
    line-height: 23px;
  }

  &::v-deep .el-table .detail-label {
    background: #fafafa;
  }

  &::v-deep .el-table .diffs-row {
    background: #fbf9e1;
  }
}
</style>
